/* eslint-disable no-unused-vars */
import { observer } from "mobx-react-lite";
import { useStore } from "../../../../../root-store-context";
import * as React from "react";
import { Button, Col, Form, Input, Modal, Row, Select, Space } from "antd";
import styles from "./RecipientItem.module.scss";
import { RecipientInfo } from "../../../../../api/Api_v2";
import { useEffect, useState } from "react";

const usStates = [
  { code: "AL", name: "Alabama" },
  { code: "AK", name: "Alaska" },
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" },
  { code: "DE", name: "Delaware" },
  { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" },
  { code: "HI", name: "Hawaii" },
  { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" },
  { code: "IN", name: "Indiana" },
  { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" },
  { code: "KY", name: "Kentucky" },
  { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" },
  { code: "MD", name: "Maryland" },
  { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" },
  { code: "MN", name: "Minnesota" },
  { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" },
  { code: "MT", name: "Montana" },
  { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" },
  { code: "NH", name: "New Hampshire" },
  { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" },
  { code: "NY", name: "New York" },
  { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" },
  { code: "OH", name: "Ohio" },
  { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" },
  { code: "PA", name: "Pennsylvania" },
  { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" },
  { code: "SD", name: "South Dakota" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UT", name: "Utah" },
  { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" },
  { code: "WA", name: "Washington" },
  { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" },
  { code: "WY", name: "Wyoming" },
];

export const EditModal = observer(
  (props: {
    isOpenModal: boolean;
    dismissModal: () => void;
    onSave: (data: RecipientInfo) => void;
    recipient?: RecipientInfo;
  }) => {
    const { isOpenModal, dismissModal, recipient, onSave } = props;
    const { modalViewerStore } = useStore();
    const [form] = Form.useForm();
    const [formData, setFormData] = useState<RecipientInfo | undefined>(
      recipient
    );

    useEffect(() => {
      if (formData?.rc_CustomAddress === "") {
        setFormData({
          ...formData,
          rc_CustomFirstName: formData.rc_FirstName,
          rc_CustomLastName: formData.rc_LastName,
          rc_CustomAddress: formData.rc_Address,
          rc_CustomAddress2: formData.rc_Address2,
          rc_CustomCity: formData.rc_City,
          rc_CustomState: formData.rc_State,
          rc_CustomZipcode: formData.rc_Zipcode,
        });
      }
    }, [recipient]);

    return (
      <Modal
        data-testid="cam-edit-recipient-modal"
        className={styles.editRecipient}
        title="Edit Recipient"
        style={{ top: "5%", padding: 0 }}
        styles={{
          body: { height: "100%", margin: 5, maxWidth: 600 },
          content: { height: "100%" },
        }}
        open={isOpenModal}
        footer={null}
        onCancel={() => {
          modalViewerStore.urlModal = "";
          dismissModal();
        }}
      >
        <Form
          form={form}
          variant="outlined"
          layout="vertical"
          initialValues={formData || {}}
          labelCol={{ span: 24 }}
          style={{ maxWidth: 900 }}
          autoComplete="off"
          onValuesChange={(changedValues, allValues) => {
            setFormData({ ...formData, ...changedValues } as RecipientInfo);
          }}
          onFinish={() => {
            if (formData) onSave(formData);
          }}
          scrollToFirstError={{ block: "center", inline: "nearest" }}
        >
          <Row style={{ paddingBottom: 8 }}>
            <Col span={8}>
              <b>Name:</b>
            </Col>
            <Col span={8} style={{ paddingLeft: 5, paddingRight: 4 }}>
              <Form.Item<RecipientInfo> label="" style={{ margin: 0 }} name="rc_CustomFirstName">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ paddingLeft: 4, paddingRight: 5 }}>
              <Form.Item<RecipientInfo> style={{ margin: 0 }} label="" name="rc_CustomLastName">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ paddingBottom: 8 }}>
            <Col span={8}>
              <b>Type:</b>
            </Col>
            <Col span={16} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Input disabled value={formData?.contactType} />
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <b>Homeowner Preference:</b>
            </Col>
            <Col span={16} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Input
                disabled
                value={formData?.rc_SendMail ? "Email" : "Physical Print"}
              />
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <b>Address:</b>
            </Col>
            <Col span={16}>
              <Form.Item<RecipientInfo> label="" name="rc_CustomAddress" style={{ margin: 5 }}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <b>Address2:</b>
            </Col>
            <Col span={16}>
              <Form.Item<RecipientInfo> label="" name="rc_CustomAddress2" style={{ margin: 5 }}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <b>City:</b>
            </Col>
            <Col span={16}>
              <Form.Item<RecipientInfo> label="" name="rc_CustomCity" style={{ margin: 5 }}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <b>State:</b>
            </Col>
            <Col span={16}>
              <Form.Item<RecipientInfo> label="" name="rc_CustomState" style={{ margin: 5 }}>
                <Select
                  data-testid="cam-recipient-state-select"
                  options={usStates.map((_) => ({
                    label: `${_.name} (${_.code})`,
                    value: _.code,
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <b>ZIP:</b>
            </Col>
            <Col span={16}>
              <Form.Item<RecipientInfo> label="" name="rc_CustomZipcode" style={{ margin: 5 }}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{ textAlign: "right", marginTop: "16px" }}>
              <Space>
                <Button data-testid="cam-edit-recipient-save-btn" size="middle" htmlType="submit">
                  Save
                </Button>
                <Button data-testid="cam-edit-recipient-cancel-btn" size="middle" type="primary" onClick={() => dismissModal()}>
                  Cancel
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
);
